// Moves focus (and scroll) to the field an error-summary row points at, once it exists in the DOM.
//
// Why it retries: pages built on EditPageLayout render only the ACTIVE section, so the caller
// activates the owning section first and the target mounts a frame or two later. Why it falls
// back: a field can legitimately not be there — in DeliveryDataV2 whole blocks live behind a
// toggle — and a summary row that focuses nothing is a dead click. `SectionCard` carries
// `tabIndex={-1}` precisely to be that landing pad.
//
// Extracted from DeliveryDataV2 and CommerceDataV2, which had the same block copy-pasted. As a
// free function over ids it is also testable, which the inline copies were not: on CommerceDataV2
// every field renders unconditionally, so the fallback branch could never be exercised from the
// page and survived every mutation.
export const MAX_FOCUS_ATTEMPTS = 2;

export const focusFieldOrSection = (fieldId: string, sectionId: string, maxAttempts = MAX_FOCUS_ATTEMPTS): void => {
  const tryFocus = (attempt: number) => {
    const field = document.getElementById(fieldId);
    // The section is only accepted as a target on the LAST attempt: while frames remain, the
    // field may still be mounting and landing on the card would steal the better destination.
    const target = field ?? (attempt >= maxAttempts ? document.getElementById(sectionId) : null);
    if (target) {
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (attempt < maxAttempts) requestAnimationFrame(() => tryFocus(attempt + 1));
  };
  requestAnimationFrame(() => tryFocus(0));
};
